import React, { useState, useEffect } from "react";
import axios from 'axios';
import { useNavigate, Link } from "react-router-dom";
import GoogleMapComponent from "./../../components/GoogleMapComponent";
import { useAuth } from "../../context/AuthContext";
import { storage, ID, Permission, Role } from "../../appwrite/config";
import AlertMessage from "../include/AlertMessage";
var _ = require('lodash');


function AddShop() {
    const [alert, setAlert] = useState({ type: "", message: "" });
    const [formData, setFormData] = useState({
        userid: '',
        categoryid: '',
        name: '',
        latitude: '',
        longitude: '',
        phone: '',
        description: '',
        isActive: false
    });
    const [errors, setErrors] = useState({});
    const [images, setImages] = useState([]);
    const [allCategories, setAllCategories] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const redirectHistory = useNavigate();
    const token = sessionStorage.getItem('JWT_TOKEN');
    const { role, user } = useAuth();


    const validate = () => {
        const newErrors = {};
        if (!formData.categoryid) newErrors.categoryid = "Category is required.";
        if (!formData.name) newErrors.name = "Name is required.";
        if (!formData.latitude) newErrors.latitude = "Latitude is required.";
        if (!formData.longitude) newErrors.longitude = "Longitude is required.";
        if (formData.phone && !/^\+\d{8,15}$/.test(formData.phone.trim())) {
            newErrors.phone = "Enter a valid phone number (e.g. +919876543210)";
        }

        if (!formData.description) newErrors.description = "Description is required.";
        return newErrors;
    };

    const handleFileChange = async (e) => {
        e.preventDefault();

        const selectedFiles = Array.from(e.target.files);

        const allowedTypes = ["image/jpeg", "image/png", "image/jpg", "image/webp"];
        const maxSize = 5 * 1024 * 1024; // ✅ 2MB

        let validFiles = [];
        let invalidFiles = [];

        selectedFiles.forEach(file => {

            // ❌ Type validation
            if (!allowedTypes.includes(file.type)) {
                invalidFiles.push(file.name + " (invalid type)");
                return;
            }

            // ❌ Size validation
            if (file.size > maxSize) {
                invalidFiles.push(file.name + " (too large)");
                return;
            }

            // ✅ Valid file
            validFiles.push(file);
        });

        // ❌ Show error if any invalid files
        if (invalidFiles.length > 0) {
            setAlert({
                type: "error",
                message: `Some files are invalid: ${invalidFiles.join(", ")}`
            });
        }

        // ✅ Add only valid images
        const newImages = validFiles.map(file => ({
            url: URL.createObjectURL(file),
            file: file,
            isNew: true
        }));

        setImages(prev => [...prev, ...newImages]);
    };

    const handleRemoveImage = (index) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this image?");
        if (!confirmDelete) return;

        const updatedImages = images.filter((_, i) => i !== index);
        setImages(updatedImages);
    };


    const handleShopAdd = async (e) => {
        e.preventDefault();
        const newErrors = validate();
        setErrors(newErrors);

        if (Object.keys(newErrors).length === 0) {
            setLoading(true);
            try {
                const uploadPromises = images.map(img =>
                    storage.createFile(
                        process.env.REACT_APP_BUCKET_ID,
                        ID.unique(),
                        img.file,
                        [
                            Permission.read(Role.any()),
                            Permission.write(Role.any())
                        ]
                    )
                );

                const uploadedFiles = await Promise.all(uploadPromises);
                const fileIds = uploadedFiles.map(file => file.$id);

                //API URL
                const response = await axios.post(`${process.env.REACT_APP_API_URL}/addshop`, {
                    "imageID": fileIds,
                    "category": formData.categoryid,
                    "name": formData.name,
                    "latitude": formData.latitude,
                    "longitude": formData.longitude,
                    "phone": formData.phone,
                    "description": formData.description,
                    "isActive": formData.isActive,
                    "userid": formData.userid
                },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + token // Replace with your token
                        }
                    }
                );

                if (response.status === 200 || response.status === 201) {
                    setAlert({ type: "success", message: "Businesses added successfully!" });
                    setTimeout(() => redirectHistory('/shops'), 2500); // thoda delay deke redirect                                        
                }

            } catch (err) {
                const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Failed to add businesses. Please try again");
                setAlert({ type: "error", message: apierror });
            }

        }
    }

    const handleLocationSelect = ({ lat, lng }) => {
        setFormData((prev) => ({
            ...prev,
            latitude: lat,
            longitude: lng,
        }));
    };

    //Get all users having the business role.
    const fetchAllUsers = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/listallusers`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token // Replace with your token
                }
            });

            const data = await response.data.data;
            if (Array.isArray(data) && data.length > 0) {
                const businessUsers = data.filter(
                    user => user.labels?.includes("business")
                );

                setAllUsers(businessUsers);
            } else {
                setAllUsers([]);
            }
        } catch (err) {
            const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Something went wrong");
            setAlert({ type: "error", message: apierror });
        } finally {
            setLoading(false);
        }
    }

    const fetchAllCategories = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/listallcategory`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token // Replace with your token
                }
            });

            const data = response.data?.documents || [];
            if (Array.isArray(data) && data.length > 0) {
                setAllCategories(data);
            } else {
                setAllCategories([]);
            }

            setLoading(false);
        } catch (err) {
            const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Something went wrong");
            setAlert({ type: "error", message: apierror });
            setLoading(false);
        } finally {
            setLoading(false);
        }

    };

    useEffect(() => {
        document.documentElement.className = "";
        if (role === "business" && user?.$id) {
            setFormData(prev => ({
                ...prev,
                userid: user.$id
            }));
        }

        fetchAllCategories();
        fetchAllUsers();
    }, []);

    return (
        <section>
            <div className="is-title-bar">
                <div className="flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0">
                    <ul>
                        <li><Link to="/dashboard" className='btn btn-primary'>Dashboard</Link></li>
                        <li><Link to="/shops" className='btn btn-primary'>Businesses</Link></li>
                        <li>Add</li>
                    </ul>
                </div>
            </div>
            <div className="section main-section">
                <div className="grid gap-6 grid-cols-1 md:grid-cols-12">
                    <div className="card">
                        <header className="card-header">
                            <p className="card-header-title">
                                <span className="icon"><i className="mdi mdi-reorder-horizontal"></i></span>
                                Add Business
                            </p>
                        </header>
                        <div className="card-content">
                            <form onSubmit={handleShopAdd}>
                                {alert.message && (
                                    <AlertMessage
                                        type={alert.type}
                                        message={alert.message}
                                        onClose={() => setAlert({ type: "", message: "" })}
                                    />
                                )}

                                <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                    <div className="field">
                                        <label className="label">Category <span style={{ color: "red" }}>*</span></label>
                                        <div className="control">
                                            <div className="select">
                                                <select id="categoryid" value={formData.categoryid} onChange={e => setFormData({ ...formData, categoryid: e.target.value })}>
                                                    <option value={''}>---Select---</option>
                                                    {allCategories.map((category, index) => (
                                                        <option value={category.$id}>{category.name}</option>
                                                    ))}
                                                </select>
                                                {errors.categoryid && <p className="help" style={{ color: 'red' }}>{errors.categoryid}</p>}
                                            </div>
                                        </div>
                                    </div>
                                    {["admin"].includes(role) ? (
                                        <div className="field">
                                            <label className="label">User </label>
                                            <div className="control">
                                                <div className="select">
                                                    <select id="userid" value={formData.userid} onChange={e => setFormData({ ...formData, userid: e.target.value })}>
                                                        <option value={''}>---Select---</option>
                                                        {allUsers.map((user, index) => (
                                                            <option value={user.$id}>{user.name}</option>
                                                        ))}
                                                    </select>
                                                    {errors.userid && <p className="help" style={{ color: 'red' }}>{errors.userid}</p>}
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <input type="hidden" id="userid" value={formData.userid} onChange={e => setFormData({ ...formData, userid: e.target.value })} />
                                    )}
                                </div>
                                <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                    <div className="field">
                                        <label className="label">Name <span style={{ color: "red" }}>*</span></label>
                                        <div className="control">
                                            <input className="input" id="name" type="text" placeholder="Name" value={formData.name} onChange={e => setFormData({ ...formData, name: e.target.value })} />
                                        </div>
                                        {errors.name && <p className="help" style={{ color: 'red' }}>{errors.name}</p>}
                                    </div>
                                    <div className="field">
                                        <label className="label">Image</label>
                                        <div className="control">
                                            <input className="input" id="simage" accept="image/*" type="file" multiple onChange={handleFileChange} />
                                        </div>
                                        {errors.simage && <p className="help" style={{ color: 'red' }}>{errors.simage}</p>}
                                    </div>
                                </div>

                                <div className="grid sm:gap-0 md:gap-6 md:grid-cols-1 sm:grid-cols-1 sm:mb-3">
                                    {/* 🆕 IMAGE PREVIEW CARD SECTION */}
                                    {images.length > 0 && (
                                        <div className="card">
                                            <header className="card-header">
                                                <p className="card-header-title">
                                                    Image Preview
                                                </p>
                                            </header>

                                            <div className="card-content">
                                                <div style={{
                                                    display: "flex",
                                                    flexWrap: "wrap",
                                                    gap: "15px"
                                                }}>
                                                    {images.map((img, i) => (
                                                        <div key={i} style={{
                                                            position: "relative",
                                                            width: "120px",
                                                            height: "100px"
                                                        }}>
                                                            {/* 🆕 DELETE BUTTON */}
                                                            <button
                                                                type="button"
                                                                onClick={() => handleRemoveImage(i)}
                                                                style={{
                                                                    position: "absolute",
                                                                    top: "-8px",
                                                                    right: "-8px",
                                                                    background: "red",
                                                                    color: "#fff",
                                                                    border: "none",
                                                                    borderRadius: "50%",
                                                                    width: "22px",
                                                                    height: "22px",
                                                                    cursor: "pointer",
                                                                    fontSize: "12px",
                                                                    zIndex: 10
                                                                }}
                                                            >
                                                                ✕
                                                            </button>

                                                            {/* IMAGE */}
                                                            <img
                                                                src={img.url}
                                                                alt="preview"
                                                                style={{
                                                                    width: "100%",
                                                                    height: "100%",
                                                                    objectFit: "cover",
                                                                    borderRadius: "6px",
                                                                    border: "1px solid #ddd"
                                                                }}
                                                            />
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                    <div className="field">
                                        <label className="label">Latitude <span style={{ color: "red" }}>*</span></label>
                                        <div className="control">
                                            <input className="input" id="latitude" readOnly type="text" placeholder="Latitude" value={formData.latitude} onChange={e => setFormData({ ...formData, latitude: e.target.value })} />
                                        </div>
                                        {errors.latitude && <p className="help" style={{ color: 'red' }}>{errors.latitude}</p>}
                                    </div>
                                    <div className="field">
                                        <label className="label">Longitude <span style={{ color: "red" }}>*</span></label>
                                        <div className="control">
                                            <input className="input" id="longitude" readOnly type="text" placeholder="Longitude" value={formData.longitude} onChange={e => setFormData({ ...formData, longitude: e.target.value })} />
                                        </div>
                                        {errors.longitude && <p className="help" style={{ color: 'red' }}>{errors.longitude}</p>}
                                    </div>
                                </div>


                                <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                    <div className="field">
                                        <label className="label">Phone</label>
                                        <div className="control">
                                            <input className="input" id="phone" type="text" placeholder="+351XXXXXXXXXX" value={formData.phone} onChange={e => setFormData({ ...formData, phone: e.target.value.replace(/\s+/g, "") })} />
                                        </div>
                                        {errors.phone && <p className="help" style={{ color: 'red' }}>{errors.phone}</p>}
                                    </div>
                                </div>
                                <div className="field">
                                    <label className="label">Description <span style={{ color: "red" }}>*</span></label>
                                    <div className="control">
                                        <textarea className="textarea" id="description" placeholder="Description" value={formData.description} onChange={e => setFormData({ ...formData, description: e.target.value })} >
                                        </textarea>
                                    </div>
                                    {errors.description && <p className="help" style={{ color: 'red' }}>{errors.description}</p>}
                                </div>
                                <div className="field spaced">
                                    <div className="control">
                                        <label className="checkbox label"><input type="checkbox" name="isActive" id="isActive" checked={formData.isActive} onChange={e => setFormData({ ...formData, isActive: e.target.checked })} />
                                            <span className="check"></span>
                                            <span className="control-label">Active</span>
                                        </label>
                                    </div>
                                </div>
                                <div className="field">
                                    <div className="control">
                                        <GoogleMapComponent onLocationSelect={handleLocationSelect} />
                                    </div>
                                </div>
                                <div className="flex justify-center items-center">
                                    <div className="field grouped">
                                        <div className="control">
                                            <button type="submit" className="button green">
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default AddShop;